import moment from 'moment';
import { useUser } from 'src/components/hooks/useUser';
import { SERVER_DATE_FORMAT } from 'src/constants/formats';

export const usePreferedDateFormat = () => {
  const { preferences } = useUser();
  const userPreferedDateFormat: string = preferences?.date_format ? preferences?.date_format : 'MM/dd/yyyy';
  const userPreferredDateTimeFormat = `${userPreferedDateFormat.toUpperCase()} hh:mm a`;

  const preferedFormatForDatePicker = (date: any) => {
    if (!date || date === 'Invalid date') {
      return null;
    }
    const convertedDate = moment(new Date(`${date}T00:00:00`)).format(userPreferedDateFormat.toUpperCase());
    const momentDate = moment(convertedDate, userPreferedDateFormat.toUpperCase()).toDate();
    return momentDate;
  };

  const preferedDateFormat = (date: any) => {
    if (!date) {
      return null;
    }
    const convertedDate = moment(new Date(`${date}T00:00:00`)).format(userPreferedDateFormat.toUpperCase());
    if (convertedDate !== 'Invalid date') {
      return convertedDate;
    } else {
      return date;
    }
  };

  const getCurrentDateInPreferedFormat = () => {
    return moment(new Date()).format(userPreferedDateFormat.toUpperCase());
  };

  const getPreferredDateTimeInLocal = (date: any) => {
    if (!date) {
      return null;
    }
    const utcDateTime = date?.replace('Z', '');
    const convertedDateTime = moment(`${utcDateTime}Z`).format(`${userPreferedDateFormat.toUpperCase()} LT`);
    if (convertedDateTime !== 'Invalid date') {
      return convertedDateTime;
    } else {
      return date;
    }
  };

  const getPreferredDateInLocal = (date: any) => {
    if (!date) {
      return null;
    }
    const convertedDate = moment(`${date}Z`).format(`${userPreferedDateFormat.toUpperCase()}`);
    if (convertedDate !== 'Invalid date') {
      return convertedDate;
    } else {
      return date;
    }
  };

  const getServerDateOrInvalidDayJs = (newDateValue: any) => {
    return String(newDateValue.$d) !== 'Invalid Date'
      ? moment(newDateValue.$d).format(SERVER_DATE_FORMAT)
      : String(newDateValue.$d);
  };

  const getServerDateOrInvalidMoment = (newDateValue: any) => {
    return String(newDateValue._d) !== 'Invalid date'
      ? moment(newDateValue._d).format(SERVER_DATE_FORMAT)
      : String(newDateValue._d);
  };

  const getServerDateFormat = (newDateValue: any) => {
    return String(newDateValue) !== 'Invalid Date'
      ? moment(newDateValue).format(SERVER_DATE_FORMAT)
      : String(newDateValue);
  };

  const getDateTimeDiffWithCurrentUTC = (dateToCheck: string) => {
    let value = moment(moment.utc(new Date()).format()).diff(`${dateToCheck}Z`, 'days');
    if (value > 0) {
      return `${value} day(s)`;
    } else {
      value = moment(moment.utc(new Date()).format()).diff(`${dateToCheck}Z`, 'hours');
      if (value > 0) {
        return `${value} hr(s)`;
      } else {
        value = moment(moment.utc(new Date()).format()).diff(`${dateToCheck}Z`, 'minutes');
        if (value > 0) {
          return `${value} min(s)`;
        } else {
          value = moment(moment.utc(new Date()).format()).diff(`${dateToCheck}Z`, 'seconds');
          if (value > 0) {
            return `${value} sec(s)`;
          }
        }
      }
    }
  };

  return {
    preferedFormatForDatePicker,
    preferedDateFormat,
    userPreferedDateFormat,
    getCurrentDateInPreferedFormat,
    getPreferredDateTimeInLocal,
    getPreferredDateInLocal,
    getServerDateOrInvalidDayJs,
    getServerDateOrInvalidMoment,
    userPreferredDateTimeFormat,
    getServerDateFormat,
    getDateTimeDiffWithCurrentUTC
  };
};
